import React from "react";
import { useStyles } from "./styles";
import {
  setFrontratingAnsweres,
  resetFrontratingAnsweres,
} from "../../../../redux/frontWebRating/actions";
import { connect } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import { saveDetails } from "../../../apiHelpers/saveDetails";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import SupportLang from "../../../../Common/SupportLang";
import { getTranslatedName } from "../../../../utils/skillTranslation";

function EmployeExperience(props) {
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();
  const [cookies, setCookie] = useCookies(["rating"]);

  const {
    webRatingData,
    webRatingAnsweres,
    setFrontratingAnsweres_,
    resetFrontratingAnsweres_,
  } = props;
  const skillsNegative = webRatingData?.skill_negative || [];

  const { getRemainingTime } = useIdleTimer({
    timeout: 1000 * 20,
    onIdle: async () => {
      getRemainingTime();
      let ratingCookie = cookies.rating;
      if (
        ratingCookie?.location !== webRatingAnsweres.location_id ||
        localStorage.getItem("is_frequent_rating")
      ) {
        const response = await saveDetails({
          ...webRatingAnsweres,
          page: 1,
          dropout_page: "n1",
        });
        if (response && response?.data?.metaData) {
          setCookie(
            "rating",
            {
              rating: "submited",
              location: response.data.metaData.location_id,
            },
            { path: "/", maxAge: 86400 }
          );
          resetFrontratingAnsweres_();
          history.push("/thankYou");
        } else {
          toast.error(response?.message);
          history.push("/frontRating");
        }
      } else {
        toast.error(
          intl.formatMessage({ id: "you-have-already-submitted-rating" })
        );
      }
    },

    debounce: 500,
  });
  const handleClick = (id) => {
    if (webRatingAnsweres.skill_id.includes(id)) {
      const eliminatedArray = webRatingAnsweres.skill_id.filter(
        (item) => item !== id
      );
      setFrontratingAnsweres_({ key: "skill_id", value: eliminatedArray });
    } else {
      setFrontratingAnsweres_({
        key: "skill_id",
        value: [...webRatingAnsweres.skill_id, id],
      });
    }
  };

  return (
    <>
      <div className={classes.container}>
        <SupportLang />
        <div className={classes.headingBox}>
          <h1 className={classes.heading}>
            {intl.formatMessage({
              id: "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong",
            })}
          </h1>
          <p className={classes.subHeading}>
            {intl.formatMessage({ id: "click-as-many-as-you-want" })}
          </p>
        </div>
        <div className={classes.tagsContainer}>
          {skillsNegative.map((skill) => (
            <p
              className={
                webRatingAnsweres.skill_id.includes(skill._id)
                  ? classes.tagTextActive
                  : classes.tagText
              }
              onClick={() => {
                handleClick(skill._id);
              }}
            >
              {getTranslatedName(skill?.translations) || skill?.name}
            </p>
          ))}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    webRatingData: state.frontWebRatingDataReducer.webRatingData,
    webRatingAnsweres: state.frontWebRatingDataReducer.webRatingAnsweres,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFrontratingAnsweres_: (data) => dispatch(setFrontratingAnsweres(data)),
    resetFrontratingAnsweres_: () => dispatch(resetFrontratingAnsweres()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeExperience);
